<template>
  <div class="create-armada bg-white">
    <div class="flex justify-between items-start shadow-border-b mdmax:flex-col">
      <div class="flex-1 p-6 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Armada</p>
        <div class="mb-6 w-44">
          <TextField type="text" label="ID" disabled />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Nama Armada" placeholder="Nama Armada" v-model="payloads.vehicle_name" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Tahun Kendaraan" placeholder="Tahun Kendaraan" v-model.number="payloads.vehicle_production_year" />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Plat Armada" placeholder="Plat Armada" v-model="payloads.vehicle_plat_id" />
        </div>
        <p class="font-bold text-lg mb-6">Upload Dokumen</p>
        <div class="mb-6">
          <FileBrowser
            id="stnk"
            label="Upload STNK"
            accept=".jpg, .png, .jpeg"
            button="Browse"
            placeholder="Pilih file yang akan di upload"
            @change="handleFileSelect($event, 'stnk', 'stnk_file_url')"
          />
          <div class="w-40 mt-4" v-if="payloads.stnk_file_url">
            <img :src="payloads.stnk_file_url" />
          </div>
        </div>
        <div class="mb-6">
          <FileBrowser
            id="bpkb"
            accept=".jpg, .png, .jpeg"
            label="Upload BPKB"
            button="Browse"
            placeholder="Pilih file yang akan di upload"
            @change="handleFileSelect($event, 'bpkb', 'bpkb_file_url')"
          />
          <div class="w-40 mt-4" v-if="payloads.bpkb_file_url">
            <img :src="payloads.bpkb_file_url" />
          </div>
        </div>
        <p class="font-bold text-lg mb-6">Foto Pendukung</p>
        <div class="">
          <FileBrowser
            id="foto"
            accept=".jpg, .png, .jpeg"
            label="Foto Armada"
            button="Browse"
            placeholder="Pilih file yang akan di upload"
            @change="handleFileSelect($event, 'armada', 'vehicle_photo_url')"
          />
          <div class="w-40 mt-4" v-if="payloads.vehicle_photo_url">
            <img :src="payloads.vehicle_photo_url" />
          </div>
        </div>
      </div>
      <div class="flex-1 p-6 mdmax:flex-auto mdmax:w-full">
        <div class="mb-2">
          <p class="font-bold text-lg mb-6">Tipe Kendaraan</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe Kendaraan</label>
            <CustomSelect :options="vehicleTypes" v-model="selectedType" optionLabel="vehicle_name" />
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Min Berat</label>
            <div class="relative">
              <TextField type="text" withIcon placeholder="Min Berat" v-model.number="payloads.minimum_supported_weight" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Box />
              </div>
              <div class="absolute right-3 top-1/2 transform -translate-y-1/2">Kg</div>
            </div>
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Max Berat</label>
            <div class="relative">
              <TextField type="text" withIcon placeholder="Max Berat" v-model.number="payloads.maximum_supported_weight" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Box />
              </div>
              <div class="absolute right-3 top-1/2 transform -translate-y-1/2">Kg</div>
            </div>
          </div>
        </div>
        <p class="font-bold text-lg mb-6">Tipe Aset</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Aset</label>
          <CustomSelect :options="ownershipTypes" v-model="selectedAssetType" optionLabel="ownership_type" />
        </div>
        <div class="dropdown mb-6" v-if="visiblePartner">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kepemilikan Aset</label>
          <CustomSelect :options="partnerVehicle" v-model="selectedPartner" optionLabel="name" />
        </div>
        <div class="shadow-border p-6 bg-neutral-200 rounded-md" v-if="selectedPartner">
          <div class="flex items-start gap-6 mb-6">
            <div class="w-44 mdmax:flex-1 mdmax:w-auto">
              <p class="text-sm font-medium mb-1 text-neutral-700">Nama</p>
              <p class="text-neutral-500">{{ selectedPartner.name }}</p>
            </div>
            <div class="">
              <p class="text-sm font-medium mb-1 text-neutral-700">No. Handphone</p>
              <p class="text-neutral-500">{{ selectedPartner.phone_number }}</p>
            </div>
          </div>
          <div class="mb-6">
            <p class="text-sm font-medium mb-1 text-neutral-700">Alamat</p>
            <p class="text-neutral-500">{{ selectedPartner.address }}</p>
          </div>
          <div class="">
            <p class="text-sm font-medium mb-1 text-neutral-700">Total Aset</p>
            <p class="text-neutral-500">{{ selectedPartner.total_vehicle }}</p>
          </div>
        </div>
        <div class="" v-if="selectedAssetType && selectedAssetType.ownership_type === 'company'">
          <div class="flex justify-between items-center mb-4">
            <p class="text-lg font-bold">Kurir</p>
            <div class="relative">
              <TextField type="text" :withIcon="true" placeholder="Cari kurir" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Search />
              </div>
            </div>
          </div>
          <TableComponent :columns="columns" :list="courier">
            <template slot="table-row" slot-scope="{ entry, column, index }">
              <Button
                v-if="column.field === 'action'"
                :buttonText="payloads.driver_id === entry.id ? 'Ditugaskan' : 'Tugaskan'"
                :type="payloads.driver_id === entry.id ? 'primary' : 'secondary'"
                size="small"
                @action="assignCourier(entry)"
              />
              <span class="block" v-else-if="column.field === 'no'">{{ index + 1 }}</span>
              <span v-else>{{ entry[column.field] }}</span>
            </template>
          </TableComponent>
          <div class="mt-8 flex justify-end items-center mb-6" v-if="filteredData && filteredData.length > 0">
            <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <!-- <Button buttonText="Draft" @action="submit()" type="secondary" :size="isMobile ? 'full' : 'regular'" /> -->
      <Button buttonText="Simpan" @action="submit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "form" */ '@/components/Forms/TextField'),
    FileBrowser: () => import(/* webpackChunkName: "form" */ '@/components/Forms/FileBrowser'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button'),
    Box: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Box'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search')
  },
  data: () => ({
    typeList: ['Perusahaan', 'Partner'],
    selectedType: null,
    selectedAssetType: null,
    selectedPartner: null,
    visiblePartner: false,
    columns: [
      { label: 'No', field: 'no' },
      { label: 'Kurir', field: 'name' },
      { label: 'Action', field: 'action' }
    ],
    payloads: {
      vehicle_name: null,
      vehicle_type: null,
      vehicle_plat_id: null,
      vehicle_production_year: null,
      minimum_supported_weight: null,
      maximum_supported_weight: null,
      vehicle_photo_url: null,
      ownership_type: null,
      ownership_id: '',
      driver_id: '',
      stnk_file_url: null,
      bpkb_file_url: null
    },
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 5,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['vehicleTypes', 'ownershipTypes']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('partner', ['partnerVehicle']),
    ...mapGetters('courier', ['courier']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    filteredData() {
      let temp = this.courier || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  watch: {
    selectedAssetType(val) {
      this.selectedPartner = null
      if (val && val.ownership_type === 'partner') {
        this.visiblePartner = true
        this.getVehicleList()
      } else if (val && val.ownership_type === 'company') {
        this.visiblePartner = false
        this.getCompanyCourier()
      }
    }
  },
  created() {
    this.getMasterData()
  },
  methods: {
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading', 'uploadImage']),
    ...mapActions('master', ['getVehicleTypes', 'getOwnershipTypes']),
    ...mapActions('partner', ['getPartnerVehicle']),
    ...mapActions('courier', ['getCourier']),
    ...mapActions('armada', ['addNewArmada']),
    assignCourier(entry) {
      this.payloads.driver_id = entry.id
    },
    onPageChange(page) {
      this.currentPage = page
    },
    getCompanyCourier() {
      this.showLoading()
      this.getCourier({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: this.searchTerm,
          sort: 'DESC'
        }
      }).then(res => {
        this.totalRecords = res.data.meta.total_item
        this.hideLoading()
      })
    },
    submit() {
      this.payloads.vehicle_type = this.selectedType.vehicle_type
      this.payloads.ownership_type = this.selectedAssetType.ownership_type
      this.payloads.ownership_id = this.payloads.ownership_type === 'partner' ? this.selectedPartner.id : ''
      this.showLoading()
      this.addNewArmada({
        partnerId: this.partnerId,
        payloads: this.payloads
      })
        .then(() => {
          this.resetData()
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 5000, primaryText: 'Penambahan Armada Berhasil', secondaryText: 'Data telah kami simpan, silahkan tutup halaman ini' }
          })
        })
        .catch(err => {
          console.log(err)
          this.hideLoading()
        })
    },
    resetData() {
      this.selectedType = null
      this.selectedAssetType = null
      this.selectedPartner = null
      this.visiblePartner = false
      this.payloads = {
        vehicle_name: null,
        vehicle_type: null,
        vehicle_plat_id: null,
        vehicle_production_year: null,
        minimum_supported_weight: null,
        maximum_supported_weight: null,
        vehicle_photo_url: null,
        ownership_type: null,
        ownership_id: '',
        driver_id: '',
        stnk_file_url: null,
        bpkb_file_url: null
      }
    },
    async getMasterData() {
      this.showLoading()
      await this.getVehicleTypes()
      await this.getOwnershipTypes()
      this.hideLoading()
    },
    async getVehicleList() {
      this.showLoading()
      this.getPartnerVehicle({
        partnerId: this.partnerId,
        params: {
          page: 1,
          per_page: 100,
          search_keyword: '',
          sort: 'DESC'
        }
      }).then(this.hideLoading())
    },
    handleFileSelect(file, purpose, target) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append('image', file)
      imageData.append('file_purpose', purpose)
      this.uploadImage({ payloads: imageData }).then(res => {
        this.hideLoading()
        this.payloads[target] = res.file_url
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
  &::v-deep .vs__dropdown-toggle {
    padding: 0;
    border-radius: 0.5rem;
    height: 50px;
  }
  &::v-deep .vs__actions {
    padding: 0px 12px 0 3px;
  }
  &::v-deep .vs__open-indicator {
    fill: #333;
  }
  &::v-deep .vs__selected {
    margin: 0;
    padding: 0 0.75rem;
  }
  &::v-deep .vs__selected-options {
    padding: 0;
  }
  &::v-deep .v-select {
    z-index: 0;
  }
}
</style>
